export const dexIntoJs: introJs.Step[] = [
  {
    title: '<span data-testid="welcome-section">WELCOME</span>',
    intro:
      '<div>Welcome to D-Mizar. Let&apos;s take a minute to learn how to best use Mizar, and become a better trader <i class="mdi mdi-trending-up text-blue-500"/> <br/><br/> Click on the <b>X</b> to exit the tutorial.</div>',
  },

  {
    title: '<span>TERMINAL</span>',
    element: '#snipe',
    intro:
      'In the Terminal you can trade all pairs on Uniswap v2.0-v3.0, Sushiswap v2.0-v3.0, and Pancakeswap v2.0-v3.0 - Ethereum, Base, and BNB chains are supported.',
    position: 'right',
    highlightClass: 'myHighlightClass',
  },

  {
    title: '<span>DASHBOARD</span>',
    element: '#dashboard',
    intro:
      'In the Dashboard you can manage your wallets, view your performance, and manage your open and close trades.',
    position: 'right',
    highlightClass: 'myHighlightClass',
  },

  {
    title: '<span data-testid="research-section">RESEARCH</span>',
    element: '#research',
    intro:
      'Use the Research dashboard to find the best wallets, hot tokens, smart waps, and explore newly launched tokens.',
    position: 'right',
    highlightClass: 'myHighlightClass',
  },

  {
    title: '<span>BOTS</span>',
    element: '#bots',
    intro:
      'Create volatility bots that automatically swings for your on-chain, or copy-trade wallets and Telegram channels.',
    position: 'right',
    highlightClass: 'myHighlightClass',
  },

  {
    title: '<span>CONNECT TO TELEGRAM</span>',
    element: '#telegram',
    intro:
      'Connect your account to Telegram and manage all your trades directly from your phone.',
    position: 'right',
    highlightClass: 'myHighlightClass',
  },

  {
    title: '<span>SWITCH CHAIN</span>',
    element: '#chains',
    intro:
      'Switch chains and explore the supported markets: Ethereum, Base, and BNB Chain.',
    position: 'right',
    highlightClass: 'myHighlightClass',
  },

  {
    title: '<span data-testid="dex-switch">CEX/DEX Switch</span>',
    element: '#dex_switch',
    intro:
      'Switch between C-Mizar and D-Mizar to move between the off-chain and on-chain world. <br/><br/> <b>CEX</b>: copy trade or trade with bots on exchanges such as Binance and Coinbase <br/> <b>DEX</b>: trade and snipe new tokens or trade with bots on the Ethereum and Base chain, and access DeFi services',
    position: 'right',
    highlightClass: 'myHighlightClass',
  },
  {
    element: '#account_star',
    title: '<span data-testid="account-section">ACCOUNT</span>',
    intro:
      '<div class="pb-2">By clicking on the <b>STAR</b>, you will get access to your account settings:</div>' +
      '<ul >' +
      '<li><b>Account</b>: edit and visualise your account settings, including notifications.</li>' +
      '<li><b>Staking</b>: by staking your $MZR tokens, you can lower your volume fees and gain entry into competitions.</li>' +
      '<li><b>Rewards</b>: invite your friends on Mizar and get up to 20% commission.</li>' +
      '</ul>',
    position: 'right',
  },
  {
    title: '<span data-testid="last-step-section">LAST STEP</span>',
    intro:
      '<div>All set for now! <i class="mdi mdi-checkbox-marked-circle text-blue-500"></i>  Check out our <a href="https://docs.mizar.com/sniper-bot-manual" target="_blank" rel="noopener noreferrer">Sniper bot manual</a> to learn even more about how our trading bots work, and to increase your profitability before starting to trade. ' +
      '<br/><br/>Join our <a href="https://discord.com/invite/gM4mAYMeWG" target="_blank" rel="noopener noreferrer">Discord</a> community to find hot alpha!</div>',
  },
];
